import React from 'react';

import { IDescriptionStatus } from './interfaces';

export const DescriptionStatus: React.FC<IDescriptionStatus> = ({
  value,
  statusFactory,
  ...other
}) => {
  return React.createElement(
    statusFactory,
    {
      value,
      ...other,
    },
    value.name
  );
};
